module.exports = __webpack_public_path__ + "static/media/7.1a0ede6a.jpg";